import React, { useEffect } from 'react'
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

function AppreciationLetter() {
    useEffect(() => {
    var swiper2 = new Swiper(".appreciation-slider", {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        speed: 1000,
        autoplay: {
            delay: 3000
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            type: "fraction",
        },
        breakpoints: {
            412: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 1,
            },
        }
    });
}, []);
  return (
    <div>
          <div className="w-100 padding bg-golden position-relative animate-section6" id="appreciation-letter">
          <a id="appreciation" name="appreciation"></a>
                <div className="container-lg">
                    <div className="heading">
                        <h6 className="text-dark">Appreciation Letter</h6>
                        <h2 className="h1 text-serif mb-0">Quality Acknowledgements</h2>
                    </div>
                    <div className="row gap-row">
                        <div className="col-lg-9 appreciation-video">
                            <video  src="https://sayahomes.com/assets/images/videos/appreciation.mp4" autoPlay loop muted playsInline className="h-100 bg-white">
                            </video>
                        </div>
                        <div className="col-lg-3 apprecial-letter-box">
                            <div className="swiper appreciation-slider">
                                <div className="swiper-wrapper">
                                    <div className="swiper-slide appreciation-slide newsBox">
                                        <a href="https://sayahomes.com/assets/images/appreciation-letters/Indian-Bank.webp" className="inner h-10" data-magnify="magnify" data-group="appre" data-caption="Indian Bank">
                                            <div className="img-fluid mt-0"><img src="https://sayahomes.com/assets/images/appreciation-letters/Indian-Bank.webp" alt="Saya Homes" className="h-100 object-cover" /></div>
                                            <article>
                                                <h5 className="news-title mt-4">Indian Bank</h5>
                                            </article>
                                        </a>
                                    </div>
                                    <div className="swiper-slide appreciation-slide newsBox">
                                        <a href="https://sayahomes.com/assets/images/appreciation-letters/Canara-Bank.webp" className="inner h-10" data-magnify="magnify" data-group="appre" data-caption="Canara Bank">
                                            <div className="img-fluid mt-0"><img src="https://sayahomes.com/assets/images/appreciation-letters/Canara-Bank.webp" alt="Saya Homes" className="h-100 object-cover" /></div>
                                            <article>
                                                <h5 className="news-title mt-4">Canara Bank</h5>
                                            </article>
                                        </a>
                                    </div>
                                    <div className="swiper-slide appreciation-slide newsBox">
                                        <a href="https://sayahomes.com/assets/images/appreciation-letters/Union-Bank.webp" className="inner h-10" data-magnify="magnify" data-group="appre" data-caption="Union Bank">
                                            <div className="img-fluid mt-0"><img src="https://sayahomes.com/assets/images/appreciation-letters/Union-Bank.webp" alt="Saya Homes" className="h-100 object-cover" /></div>
                                            <article>
                                                <h5 className="news-title mt-4">Union Bank</h5>
                                            </article>
                                        </a>
                                    </div>
                                </div>
                                <div className="bottomControls justify-content-lg-start px-0">
                                    <div className="swiper-button-prev solid"></div>
                                    <div className="swiper-button-next solid"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
  )
}

export default AppreciationLetter